const geterateUuidFallback = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.trunc(Math.random() * 16);
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
};

const geterateUuid = () => {
  const USER_UUID = crypto?.randomUUID
    ? crypto.randomUUID()
    : geterateUuidFallback();

  return USER_UUID;
};

export default defineNuxtPlugin({
  name: 'uuid',
  dependsOn: ['pinia-persistence'],

  setup() {
    const store = useKegelAnalyticStore();
    const route = useRoute();
    const cookieUuid = useCookie('user-uuid', {
      default: () => '',
      maxAge: 7 * 24 * 60 * 60,
    });
    const uuidFromQuery = route.query?.uuid || route.query?.user_uuid;
    const startScreenUuid = (globalThis as any).__aoBeacon?.uuid as string | undefined;
    let user = uuidFromQuery as string || cookieUuid.value as string || startScreenUuid;

    if (!user) {
      user = geterateUuid();
      store.userUuid = String(user);
      cookieUuid.value = user;
    } else {
      cookieUuid.value = user;
      store.userUuid = user;
    }
  },
});
